import { useSelector } from "react-redux";
import { selectUser } from "../../Redux/user/user";
import { PERMISSIONS } from "./Permissions";

export default function usePermissions() {
	const user = useSelector(selectUser);
	const role = user?.roles?.[0];
	const permissions = PERMISSIONS[role] || [];

	return (scope) => permissions.includes(scope);
}
